import type { Variants } from "motion/react";

const easeBezier = [0.36, 0.66, 0.4, 1] as const;

export const scaleSpringOpacity = {
  initial: {
    opacity: 0,
    transform: "scale(0.8)",
  },
  enter: {
    opacity: 1,
    transform: "scale(1)",
    transition: {
      type: "spring" as const,
      bounce: 0,
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    transform: "scale(0.7)",
    transition: {
      type: "tween" as const,
      duration: 0.18,
      ease: "easeOut" as const,
    },
  },
} satisfies Variants;

export const scaleSpring = {
  enter: {
    transform: "scale(1)",
    opacity: 1,
    transition: {
      type: "spring" as const,
      bounce: 0,
      duration: 0.3,
    },
  },
  exit: {
    transform: "scale(0.6)",
    opacity: 0,
    transition: {
      type: "tween" as const,
      duration: 0.2,
      ease: "easeOut" as const,
    },
  },
} satisfies Variants;

export const ease = easeBezier;

export const fade = {
  enter: {
    opacity: 1,
    transition: {
      duration: 0.4,
      ease: easeBezier,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: easeBezier,
    },
  },
} satisfies Variants;

export const modalScaleInOut = {
  enter: {
    scale: 1,
    opacity: 1,
    transition: {
      scale: {
        duration: 0.4,
        ease: easeBezier,
      },
      opacity: {
        duration: 0.4,
        ease: easeBezier,
      },
      y: {
        type: "spring" as const,
        bounce: 0,
        duration: 0.6,
      },
    },
  },
  exit: {
    scale: 1.03,
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: easeBezier,
    },
  },
} satisfies Variants;
